import { render, staticRenderFns } from "./table-people.vue?vue&type=template&id=6124e043&"
import script from "./table-people.vue?vue&type=script&lang=js&"
export * from "./table-people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports